import {brandConfigObjectMap, Brands} from "@/brand/brandConfig";

export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', getBrandConfig(Brands.BattleLeagueGamingMalaysia));
brandConfigMap.set('https://my-play.blg.gg', getBrandConfig(Brands.BattleLeagueGamingMalaysia));
brandConfigMap.set('default', getBrandConfig(Brands.BattleLeagueGamingMalaysia));

export function getBrandConfig(brand) {
    const brandConfigObject = brandConfigObjectMap.get(brand);
    return {
        brand,
        assetBrand: brandConfigObject?.assetBrand ?? brand,
        ...brandConfigObject
    }
}
